// Pure slug helpers shared by the React app and the meta sidecar (meta-service/).
// Re-exported from utilities/helpers so existing imports keep working.

export const toSlug = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/<[^>]*>/g, ' ')
    .replace(/[_\s]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const buildSlugId = (
  text: string | null | undefined,
  id: string,
  maxSlugLength = 40
): string => {
  if (!id) return id;
  if (!text) return id;
  const slug = toSlug(text).slice(0, maxSlugLength).replace(/-+$/, '');
  return slug ? `${slug}-${id}` : id;
};

export const extractIdFromSlug = (slugId: string | undefined): string => {
  if (!slugId) return '';
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(slugId)) {
    return slugId;
  }
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const match = slugId.match(uuidRegex);
  if (match) return match[0];
  const lastHyphen = slugId.lastIndexOf('-');
  return lastHyphen !== -1 ? slugId.slice(lastHyphen + 1) : slugId;
};
